import { render } from "./ErrorMsg.vue?vue&type=template&id=2032f158&lang=pug"
import script from "./ErrorMsg.vue?vue&type=script&lang=js"
export * from "./ErrorMsg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/inputs/ErrorMsg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2032f158"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2032f158', __exports__)) {
    api.reload('2032f158', __exports__)
  }
  
  module.hot.accept("./ErrorMsg.vue?vue&type=template&id=2032f158&lang=pug", () => {
    api.rerender('2032f158', render)
  })

}


export default __exports__